import useStats from "../Hooks/useStats";

const HitsStats = props => {
    const {
        hitsPerPage,
        nbHits,
        nbSortedHits,
        page,
    } = useStats(props);

    return (
        <>
            {
                nbHits > 0 ?
                    <div className={'tracking-wide text-center'}>
                        <p className={'text-md font-title text-indigo-800 select-none'}>
                            <span>Annonces </span>
                            <span className={'font-bold'}>{page === 0 ? 1 : page * hitsPerPage} à {(page === 0 ? 1 : page * hitsPerPage) + hitsPerPage <= nbHits ? (page * hitsPerPage) + hitsPerPage : nbHits}</span>
                            <span> sur {nbHits}</span>
                        </p>
                    </div> :
                    null
            }
        </>
    );
}

export default HitsStats